module.exports = __webpack_public_path__ + "img/icon-bathroom.da5d917a.svg";